import React from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import StrengthPerformance from './StrengthPerformance';
import { convertCalifTxt, convertDesviacionToString } from '../helpers/ResultsHelpers';



type FortalezasPerformanceProps= {
  infoCompetencies:any
}


const FortalezasPerformance = ({infoCompetencies}:FortalezasPerformanceProps) => {

  

const sumResultsAndCount = (data: Array<{ [key: string]: any }>):{ califFinal: number, count: number,sumResult:number }  => {

  const filteredData = data.filter(item => {
      switch (item.typeEval) {
          case 'autoevaluacion':
              return Number(item.pesoAuto) > 0;
          case 'lider':
              return Number(item.pesoLider) > 0;
          case 'colega':
              return Number(item.pesoColega) > 0;
          case 'subordinado':
              return Number(item.pesoSubordinado) > 0;
          case 'cliente':
              return Number(item.pesoCliente) > 0;
          default:
              return false;
      }
  });
  let sumResult = 0;  
  const results = filteredData.map(evalItem => {
    if (evalItem.minReq > 0) {
      sumResult += evalItem.result;
      const res= (evalItem.result/evalItem.minReq ) * 100
      return res > 100 ? 100 :res;
    }
    return 0;
  });
  
  const sum = results.reduce((total, num) => total + num, 0);
  const count = filteredData.length;  
  const califFinal=  Number((sum/count).toFixed(2))
  return { califFinal, count,sumResult };  
};

const addSumAndCount = (competences: Array<{ infoEvalByCompetence: Array<{ [key: string]: any }> }>) => {
  return competences.map(competence => {
      const { califFinal, count, sumResult } = sumResultsAndCount(competence.infoEvalByCompetence);
      return {
          ...competence,
          infoEvalByCompetence: competence.infoEvalByCompetence.map(item => ({
              ...item,
              califFinal,
              count,
              estado: convertCalifTxt(item.calEsperada,convertDesviacionToString(sumResult / count)),  
              evalTxt: convertDesviacionToString(sumResult / count)
          }))
      };
  });
};
 
  const competencesWithSumAndCount = addSumAndCount(infoCompetencies);  
  const updatedInfoCompetencies = competencesWithSumAndCount.map(competence => {
      const estado = competence.infoEvalByCompetence[0]?.estado || 'undefined';
      return {
          ...competence,
          estado
      };
  }); 

   const filteredCompetencies = updatedInfoCompetencies.filter((infoByCompetence: { estado: string; }) => 
      infoByCompetence.estado === 'strength'
   );

   const sortedFortaleza = filteredCompetencies
   .filter((infoByCompetence: { estado: string; }) => infoByCompetence.estado === 'strength')
   .sort((a, b) => {
       return (b.infoEvalByCompetence[0]?.califFinal || 0) - (a.infoEvalByCompetence[0]?.califFinal || 0);
   });



  return (
    <>
    <div className='containerTxtFortalezas'>
      <div><span className='titleStrength'> Fortalezas</span></div>
      <div><span className='descriptionStrength'>Indicadores en los que se ha alcanzado o superado la nota requerida. Los indicadores han sido ordenados de mayor a menor fortaleza.</span></div>
    </div>
    <div className='containerTableStrength'>
    <>    
 <TableContainer >
      <Table sx={{ minWidth: 500 }} aria-label="simple table">
        <TableBody>
        {
        sortedFortaleza.length >0 ?
          sortedFortaleza.map((row:any) => (
            <TableRow
              key={row.id}            
            >
              <TableCell>
              <div className="containerEvalRes">
                <div className="containerStrengthPerformance">
                 <StrengthPerformance
                    infoEval={row}                    
                /> 
              </div>  
              </div>  
              </TableCell>              
            </TableRow>
          ))
          :(
            <TableRow>
              <TableCell>
              <div className="containerEvalRes">
                <div className="containerStrengthPerformance">
                   No hay competencias que pueda mejorar
              </div>  
              </div>  
              </TableCell>              
            </TableRow>      
          )
        }
        </TableBody>
      </Table>
    </TableContainer>   
    </>
    </div>
    </>
  )
}

export default FortalezasPerformance